var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterIconBlomberg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0163 14.1171L7.29419 14.5058L7.68286 11.7836L14.6833 4.78323C14.9927 4.4738 15.4124 4.29996 15.85 4.29996C16.2876 4.29996 16.7073 4.4738 17.0167 4.78323C17.3262 5.09267 17.5 5.51236 17.5 5.94997C17.5 6.38758 17.3262 6.80726 17.0167 7.1167L10.0163 14.1171Z",
    stroke: "#CC0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25005 1H4.85005C4.54629 1 4.30005 1.24624 4.30005 1.55V2.65C4.30005 2.95376 4.54629 3.2 4.85005 3.2H9.25005C9.55381 3.2 9.80005 2.95376 9.80005 2.65V1.55C9.80005 1.24624 9.55381 1 9.25005 1Z",
    stroke: "#CC0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80005 2.10001H12C12.2918 2.10001 12.5716 2.2159 12.7779 2.42219C12.9842 2.62848 13.1 2.90827 13.1 3.20001",
    stroke: "#CC0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 14.2V16.4C13.1 16.6917 12.9841 16.9715 12.7778 17.1778C12.5715 17.3841 12.2917 17.5 12 17.5H2.1C1.80826 17.5 1.52847 17.3841 1.32218 17.1778C1.11589 16.9715 1 16.6917 1 16.4V3.20001C1 2.90827 1.11589 2.62848 1.32218 2.42219C1.52847 2.2159 1.80826 2.10001 2.1 2.10001H4.3",
    stroke: "#CC0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30005 6.5H9.80005",
    stroke: "#CC0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30005 9.79999H6.50005",
    stroke: "#CC0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterIconBlomberg);
export default __webpack_public_path__ + "static/media/registerIcon-blomberg.58d2eafc0f25aa074d413d03586746f0.svg";
export { ForwardRef as ReactComponent };